<template>
  <vx-card no-shadow>
    <div>
      <vs-input 
        class="w-full" 
        label-placeholder="Contraseña anterior" 
        v-model="old_password" />
      <span
        class="text-danger text-sm"
        v-show="errors.has('old_password') || formerr.includes('old_password')">
        Por favor ingrese la contraseña anterior
      </span>

      <vs-input 
        class="w-full mt-base" 
        label-placeholder="Nueva contraseña" 
        v-model="new_password" />
      <span
        class="text-danger text-sm"
        v-show="errors.has('new_password') || formerr.includes('new_password') || formerr.includes('confirm_password')">
        {{formerr.includes('confirm_password') ? 'Las constraseñas no coincide' : 'Por favor ingrese la nueva contraseña'}}
      </span>

      <vs-input 
        class="w-full mt-base" 
        label-placeholder="Confirmar contraseña" 
        v-model="confirm_new_password" />
      <span
        class="text-danger text-sm"
        v-show="errors.has('confirm_new_password') || formerr.includes('confirm_new_password') || formerr.includes('confirm_password')">
        {{formerr.includes('confirm_password') ? 'Las constraseñas no coincide' : 'Por favor ingrese la confirmación de la contraseña'}}
      </span>
      <div class="mt-4">
        <div
          v-show="errors.has('validate_password') || formerr.includes('validate_password')"
          v-for="message in this.passwordValidationMessages"
          :key="message"
        >
          <span class="text-danger text-sm">
            {{message}}
          </span>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end mt-base">
        <vs-button 
          class="ml-auto mt-2"
          @click="actionSaveData"
        >Guardar</vs-button>
        <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button> -->
      </div>
    </div>
  </vx-card>
</template>

<script>

import UsuarioModule from '@/store/user-module/moduleDataList.js'

export default {
  data () {
    return {
      formerr: [],
      old_password: null,
      new_password: null,
      confirm_new_password: null,
      passwordValidationMessages: []
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.formerr.length <= 0
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  created () {
    if (!UsuarioModule.isRegistered) {
      this.$store.registerModule('UsuarioModule', UsuarioModule)
      UsuarioModule.isRegistered = true
    }

    //console.log('user', this.$store.state.auth.userDetails())
  },
  methods: {
    actionSaveData () {

      this.formerr = []
      if (
        this.old_password === null ||
        this.old_password === undefined ||
        this.old_password.trim() === ''
      ) {
        this.formerr.push('old_password')
      }
      if (
        this.new_password === null ||
        this.new_password === undefined ||
        this.new_password.trim() === ''
      ) {
        this.formerr.push('new_password')
      }
      if (
        this.confirm_new_password === null ||
        this.confirm_new_password === undefined ||
        this.confirm_new_password.trim() === ''
      ) {
        this.formerr.push('confirm_new_password')
      }
      
      if (this.new_password !== null && this.confirm_new_password !== null) {
        if (this.new_password !== this.confirm_new_password) {
          this.formerr.push('confirm_password')
        }
      }

      if (this.validateForm && this.validatePassword()) {
        const data = {
          idUser: this.$store.state.auth.userDetails().id,
          old_password: this.old_password,
          new_password: this.new_password
        }

        this.changePassword(data)
      }
    },
    validatePassword () {

      this.passwordValidationMessages = []
      let returnValue = false

      //Modules
      const ONE_DIGIT = /(?=.*[0-9])/  //(?=.*[0-9]) a digit must occur at least once
      const ONE_DIGIT_B = ONE_DIGIT.test(this.new_password)
      if (!ONE_DIGIT_B) {
        this.passwordValidationMessages.push('- Un dígito debe aparecer al menos una vez.')
      }

      const LOWER_CASE = /(?=.*[a-z])/  //(?=.*[a-z]) a lower case letter must occur at least once
      const LOWER_CASE_B = LOWER_CASE.test(this.new_password)
      if (!LOWER_CASE_B) {
        this.passwordValidationMessages.push('- Una letra minúscula debe aparecer al menos una vez.')
      }

      const UPPER_CASE = /(?=.*[A-Z])/  //(?=.*[A-Z]) an upper case letter must occur at least once
      const UPPER_CASE_B = UPPER_CASE.test(this.new_password)
      if (!UPPER_CASE_B) {
        this.passwordValidationMessages.push('- Una letra mayúscula debe aparecer al menos una vez.')
      }

      const NO_SPACE = /(?=\S+$)/  //(?=\\S+$) no whitespace allowed in the entire string
      const NO_SPACE_B = NO_SPACE.test(this.new_password)
      if (!NO_SPACE_B) {
        this.passwordValidationMessages.push('- No se permiten espacios en blanco en la contraseña.')
      }

      const SPECIAL_CHAR = /(?=.*[@#$%^&+=])/ //(?=.*[@#$%^&+=]) a special character must occur at least once
      const SPECIAL_CHAR_B = SPECIAL_CHAR.test(this.new_password)
      if (!SPECIAL_CHAR_B) {
        this.passwordValidationMessages.push('- Un carácter especial debe aparecer al menos una vez.')
      }

      let MIN_MAX_CHAR_B = false
      if (this.new_password.length >= 8 && this.new_password.length <= 20) {
        MIN_MAX_CHAR_B = true
      } else {
        this.passwordValidationMessages.push('- Mínimo de 8 caracteres y máximo de 20 caracteres.')
      }

      if (ONE_DIGIT_B && LOWER_CASE_B && UPPER_CASE_B && NO_SPACE_B && SPECIAL_CHAR_B && MIN_MAX_CHAR_B) {
        returnValue = true
      } else {
        this.formerr.push('validate_password')
      }
      
      return returnValue
    },
    changePassword (data) {
      this.$vs.loading()

      this.$store
        .dispatch('UsuarioModule/changePassword', data)
        .then(() => {
          this.$vs.loading.close()

          this.$vs.dialog({
            color: 'success',
            title: 'Aviso',
            text: 'La contraseña ha sido cambiada correctamente.',
            acceptText: 'Aceptar'
          })

          this.old_password = null
          this.new_password = null
          this.confirm_new_password = null
        })
        .catch((ex) => {
          this.$vs.loading.close()

          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOK !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.v_errm,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    }
  }
}
</script>
